<template>
  <div>
    <table class="table">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col">Cargo</th>
          <th scope="col">Nombre</th>

          <th scope="col">
            <b-button v-if="!readOnly" class="button-add" @click="addItemList"
              >+</b-button
            >
          </th>
        </tr>
      </thead>

      <tbody v-if="readOnly">
        <Row
          v-for="(item, index) in itemList"
          :key="index"
          :removeItem="removeItem"
          :objTest="item"
          :readOnly="readOnly"
        />
      </tbody>

      <draggable v-else :list="itemList" tag="tbody">
        <Row
          v-for="(item, index) in itemList"
          :key="index"
          :removeItem="removeItem"
          :objTest="item"
          :readOnly="readOnly"
        />
      </draggable>
    </table>
  </div>
</template>

<script>
import Row from "./Row.vue";
import draggable from "vuedraggable";
export default {
  components: {
    Row,
    draggable,
  },
  props: ["itemList", "removeItem", "addItemList", "readOnly"],
  methods: {
    saveData: function() {
      console.log(this.itemList);
    },
  },
};
</script>

<style scoped>
.titulo-c3 {
  font-size: 1.1rem;
  color: #2b425f;
  font-weight: bold;
  margin: 10px 15px;
}
.table > tbody,
.table > thead {
  vertical-align: middle;
}
.table {
  border: 1px solid #ccc;
}
.button-add {
  background: #25a2b7 !important;
  color: white !important;
  border: none;
  width: 25px;
  height: 25px;
  border-radius: 14px;
  padding: 0 !important;
  font-size: 1.5rem;
  font-weight: bold;
  line-height: 0;
}
</style>
